import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=ef066304&scoped=true&"
import script from "./AddArea.vue?vue&type=script&lang=ts&"
export * from "./AddArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef066304",
  null
  
)

export default component.exports